<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="10" offset-sm="1" md="8" offset-md="2" lg="8" xl="6" offset-xl="3">
        <v-card outlined>
          <v-card-title>SAV Terms</v-card-title>
          <v-card-text>
            <p>Welcome to Silent Auction Vacations package terms</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home"
};
</script>


